import {
  Description,
  Field,
  Input as HeadlessUiInput,
  Label,
} from "@headlessui/react"

interface Props {
  autoComplete?: string
  autoFocus?: boolean
  className?: string
  description?: React.ReactNode | string
  disabled?: boolean
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"]
  invalid?: boolean
  label?: string
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  type?: string
  value?: string
}

export default function Input({
  autoComplete,
  autoFocus = false,
  className = "",
  description,
  disabled = false,
  inputMode,
  invalid = false,
  label,
  name,
  onChange,
  placeholder = "",
  type = "text",
  value,
}: Props) {
  return (
    <Field className="space-y-2">
      {label && (
        <Label className="block text-sm font-semibold text-vm-ink">
          {label}
        </Label>
      )}

      <HeadlessUiInput
        // NOTE: Without a visible label the placeholder doubles as the
        // accessible name, so screen readers still announce the field.
        aria-label={label ? undefined : placeholder || undefined}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={`vm-input ${className}`}
        disabled={disabled}
        inputMode={inputMode}
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />

      {description && (
        <Description
          className={`text-xs leading-relaxed ${invalid ? "text-vm-red" : "text-vm-muted"}`}
        >
          {description}
        </Description>
      )}
    </Field>
  )
}
